import React from 'react';
import InlineMessage from '@atlaskit/inline-message';
import { Radio } from '@atlaskit/radio';
import { PaymentMethod, PaymentMethodType, PaymentOnTerms } from '@css-xp/graphtypes';
import { PaymentMethodId, PaymentMethodPanel } from '@atlassian/commerce-payment-methods';
import './additional-payment-methods.scss';
import { Divider } from '../../divider';

type Props = {
  isTermPaymentAvailable: boolean;
  deferredPaymentMethods: any[];
  defaultPaymentMethodId: string | null;
  selectPaymentMethod: (id: string) => void;
  selectedPaymentMethodId: string;
  header?: string;
};

const renderDefferedPaymentMethod = (deferredPaymentMethod: PaymentMethod, defaultPaymentMethodId: string | null) => {
  if (deferredPaymentMethod.type === PaymentMethodType.DEFERRED) {
    const paymentOnTerms = deferredPaymentMethod as PaymentOnTerms;

    return (
      <PaymentMethodPanel
        key={paymentOnTerms.id}
        paymentMethod={{
          id: paymentOnTerms.id as PaymentMethodId,
          type: paymentOnTerms.type,
          default: defaultPaymentMethodId === paymentOnTerms.id,
        }}
      />
    );
  }
  return;
};

const AdditionalPaymentMethods = ({
  deferredPaymentMethods,
  defaultPaymentMethodId,
  selectPaymentMethod,
  selectedPaymentMethodId,
  isTermPaymentAvailable,
  header,
}: Props) => {
  deferredPaymentMethods as PaymentOnTerms[];

  return (
    <div className="additional-payment-methods-container" data-testid="additional-payments">
      {header && <p className="additional-payment-methods-header">{header}</p>}
      <div className="term-payment-container">
        <Radio
          label="Term Payment"
          name="radio-pay-on-terms"
          testId="radio-pay-on-terms"
          isChecked={isTermPaymentAvailable && deferredPaymentMethods[0].id === selectedPaymentMethodId}
          onChange={() => {
            if (isTermPaymentAvailable) {
              selectPaymentMethod(deferredPaymentMethods[0].id);
            }
          }}
          isDisabled={!isTermPaymentAvailable}
        />
        <div className="term-payment-details">
          <div className="warning-message-container">
            {isTermPaymentAvailable ? (
              <InlineMessage type="warning" secondaryText="Term payment can't be disabled once it's set." />
            ) : (
              <InlineMessage type="warning" secondaryText="Term payment option selection not allowed." />
            )}
          </div>
          <div className="term-payments">
            {deferredPaymentMethods &&
              deferredPaymentMethods.length > 0 &&
              deferredPaymentMethods.map((paymentMethod) => {
                return renderDefferedPaymentMethod(paymentMethod, defaultPaymentMethodId);
              })}
          </div>
        </div>
      </div>
      <Divider />
      <Radio label="Pay on account" name="radio-pay-on-account" testId="radio-pay-on-account" isDisabled />
    </div>
  );
};

export default AdditionalPaymentMethods;
